import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDateApr = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("g", {
			id: `${__svgrId}-Date Icons`,
			children: /* @__PURE__ */ _jsx("g", {
				id: `${__svgrId}-Icon / Date / April`,
				children: /* @__PURE__ */ _jsxs("g", {
					id: `${__svgrId}-Icons`,
					children: [
						/* @__PURE__ */ _jsx("rect", {
							height: 24.9624,
							id: `${__svgrId}-Rectangle 61`,
							stroke: "white",
							strokeLinejoin: "round",
							strokeWidth: 2.5,
							style: { fill: "var(--sticker-pastel,#FFC98E)" },
							width: 22.4432,
							x: 4.6789,
							y: 3.9967
						}),
						/* @__PURE__ */ _jsx("rect", {
							height: 22.4624,
							id: `${__svgrId}-Rectangle 59`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: {
								fill: "var(--sticker-pastel,#FFC98E)",
								stroke: "var(--sticker-dark,#9A6528)"
							},
							width: 19.9432,
							x: 5.9289,
							y: 5.2468
						}),
						/* @__PURE__ */ _jsx("rect", {
							fill: "white",
							height: 12.9712,
							id: `${__svgrId}-Rectangle 60`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#9A6528)" },
							width: 19.9432,
							x: 5.9311,
							y: 14.7382
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M8.419 12.8962 L10.4511 7.2961 L11.899 7.2961 L13.939 12.8961 L12.603 12.8961 L12.211 11.7361 L10.131 11.7361 L9.7311 12.8962 L8.419 12.8962 Z M10.4831 10.7281 L11.867 10.7282 L11.163 8.6882 L10.4831 10.7281 Z M14.2381 12.8961 L14.2381 7.2961 L16.4621 7.2961 C16.8462 7.2961 17.1928 7.3655 17.5021 7.5041 C17.8114 7.6428 18.0541 7.8428 18.2301 8.1042 C18.4114 8.3654 18.5021 8.6775 18.5021 9.0401 C18.5021 9.3975 18.4141 9.7095 18.2381 9.9761 C18.0674 10.2375 17.8275 10.4402 17.5181 10.5841 C17.2142 10.7281 16.8621 10.8001 16.4621 10.8002 L15.5021 10.8001 L15.5021 12.8961 L14.2381 12.8961 Z M15.5021 9.7202 L16.4301 9.7201 C16.7287 9.7201 16.9341 9.6535 17.0461 9.5201 C17.1635 9.3814 17.2221 9.2215 17.2221 9.0401 C17.2221 8.8695 17.1635 8.7174 17.0461 8.5841 C16.9341 8.4455 16.7288 8.3761 16.4301 8.3761 L15.5021 8.3761 L15.5021 9.7202 Z M18.8925 12.8962 L18.8925 7.2961 L21.0284 7.2962 C21.4125 7.2961 21.7512 7.3628 22.0445 7.4961 C22.3378 7.6295 22.5671 7.8215 22.7325 8.0722 C22.8978 8.3175 22.9804 8.6108 22.9804 8.9521 C22.9805 9.3255 22.8791 9.6374 22.6764 9.8881 C22.4738 10.1388 22.1938 10.3174 21.8364 10.4241 L23.3645 12.8961 L21.9085 12.8961 L20.5725 10.6161 L20.1565 10.6162 L20.1564 12.8962 L18.8925 12.8962 Z M20.1565 9.5441 L21.0045 9.5441 C21.2018 9.5441 21.3485 9.5148 21.4445 9.4562 C21.5458 9.3921 21.6152 9.3148 21.6525 9.2242 C21.6898 9.1335 21.7085 9.0428 21.7084 8.9521 C21.7085 8.8614 21.6898 8.7735 21.6525 8.6881 C21.6152 8.5975 21.5459 8.5228 21.4445 8.4641 C21.3485 8.4055 21.2018 8.3762 21.0045 8.3762 L20.1565 8.3762 L20.1565 9.5441 Z",
							id: `${__svgrId}-APR`,
							style: { fill: "var(--sticker-dark,#9A6528)" }
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 34`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 9.942,
							x2: 9.942,
							y1: 15.3986,
							y2: 27.0677
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 38`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 13.9199,
							x2: 13.9198,
							y1: 15.3984,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 36`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5944,
							x2: 25.153,
							y1: 19.1321,
							y2: 19.1321
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 37`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5949,
							x2: 25.1535,
							y1: 23.0835,
							y2: 23.0835
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 35`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 17.7503,
							x2: 17.7503,
							y1: 15.3984,
							y2: 27.0675
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 39`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 21.7954,
							x2: 21.7954,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M12.8152 4.3477 L12.8151 6.1461",
							id: `${__svgrId}-Line 40`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#9A6528)" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M19.2456 4.3477 L19.2456 6.146",
							id: `${__svgrId}-Line 41`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#9A6528)" }
						})
					]
				})
			})
		})
	});
};
export default SvgDateApr;
